import React from 'react';

export type UsernameColorPreset = {
  colour1?: string;
  colour2?: string;
};

export function getUsernameStyles({
  customColor,
  defaultColor,
}: {
  customColor?: UsernameColorPreset;
  defaultColor?: string;
}) {
  console.log({ customColor, defaultColor });
  let style: React.CSSProperties = {
    color: defaultColor || '#7b7170',
  };

  // If has custom color (premium feature)
  if (customColor) {
    const { colour1, colour2 } = customColor;
    style = {
      backgroundImage: `linear-gradient(to right, ${colour1}, ${colour2})`,
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    };
  }

  return style;
}
